import '../../public/css/media/_sign_up.scss';
import React from 'react';
import {Link,} from 'react-router';
import FacebookLogin from './FacebookLogin';
import Recaptcha from 'react-recaptcha';
import MobileHeaderSidenav from './Layout/Header/MobileHeader';
import Footer from './Layout/Footer/Footer';
import { extensionDetect, mapPrefixNumber } from '../utils/utils';
import { v4 as uuid } from 'uuid';
import { warehouseAND } from '../constants/warehouseCode';
import logo from '../assets/images/brand-logo.svg';

/* eslint-disable */
const appConfig = require('webpack-config-loader!../app-config.js');
const fbAppId = appConfig.fbAppId;
const extensionId = appConfig.extensionId;
/* eslint-enable */

const createReactClass = require('create-react-class');
const SignUp = createReactClass({

    componentWillMount() {
        const script = document.createElement("script");

        var x = document.getElementsByClassName("lbcx");

        for (var i = 0; i < x.length; i++) {
            document.body.removeChild(x.item(i));
        }

        script.setAttribute('class', 'lbcx');
        script.src = "js/custom.js";
        script.async = true;

        document.body.appendChild(script);

        this.props.getCopyrightYear();

        localStorage.removeItem('checkoutModalShowed');

        document.title = "Sign up | ShippingCart";

      const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
      const isMac = navigator.userAgent.toLowerCase().indexOf('mac') > -1;
      if(isChrome){
        if(!isMac){
          extensionDetect(extensionId)
        }
      }else{
        localStorage.setItem("cartExtensionModalShowed", true)
      }
    },

    componentDidMount() {
      window.scrollTo(0, 0)

      // <!-- Lightning Bolt Begins -->
      const lbscript = document.createElement("script");
      lbscript.type = "text/javascript";
      lbscript.src = "/js/lightningbolt.js";
      lbscript.async = true;
      document.body.appendChild(lbscript);

      const lbscript1 = document.createElement("script");
      lbscript1.type = "text/javascript";
      lbscript1.setAttribute('id', 'lightning_bolt');
      lbscript1.src = "//cdn-akamai.mookie1.com/LB/LightningBolt.js";
      lbscript1.async = true;
      document.body.appendChild(lbscript1);
      // <!-- Lightning Bolt Ends -->
    
      localStorage.setItem('grabKey', this.queryParam("s2s"));
    },

    componentWillUnmount(){
      this.props.resetAccounts();
    },

    componentDidUpdate() {
        if (this.state.submitted) {
            window.scrollTo(0, 0);
            var status = this.props.error ? this.props.error.response.status : 200;

            if (status !== 200) {
                this.refs.notify_error.parentElement.className = "notify";

                var errText = document.getElementsByClassName('input-error');
                var errKey = errText.length;

                while (errKey--) {
                    errText[errKey].parentElement.className = "control";
                    errText[errKey].className = "disnone";
                }

                if (status === 422) {
                    var errors = this.props.error.response.data.errors;

                    for (var i = 0; i < errors.length; i++) {
                        this.refs["errors_" + errors[i].title].innerHTML = errors[i].detail;
                        this.refs["errors_" + errors[i].title].className = "input-error";
                        this.refs["errors_" + errors[i].title].parentElement.className = "control has-error";
                    }
                }
            }
        }
    },

    componentWillReceiveProps(nextProps) {
      if (nextProps.register.fetched){
        this.setState({
          showModal: true
        })
      }
    },

    responseFacebook(response) {
        const token = response.accessToken;
        this.props.FacebookSignedUp(token);
    },

    getInitialState: function () {
        return {
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            password_confirmation: '',
            contact_number: '',
            submitted: false,
            recaptcha: '',
            countryPrefix: '+63',
            errors: ['first_name', 'last_name', 'email', 'password', 'password_confirmation', 'phone_number', 'gender', 'birthdate', 'recaptcha',],
        }
    },
    clearErrors() {
        this.state.errors.forEach(error => {
            this.refs[`errors_${error}`].innerHTML = '';
            this.refs[`errors_${error}`].className = '';
        });
    },

   handleSubmit(e) {
        e.preventDefault();
        this.clearErrors();
        if (this.state.contact_number.length < 7) {
            this.refs["errors_phone_number"].innerHTML = 'Phone number should have minimum of 7 digits.';
            this.refs["errors_phone_number"].className = "input-error";
            this.refs["errors_phone_number"].parentElement.className = "control has-error";
            return
        }
        this.refs.notify_error.parentElement.className = "disnone";
        const email = this.state.email;
        const password = this.state.password;
        const password_confirmation = this.state.password_confirmation;
        const first_name = this.state.first_name;
        const middle_name = "";
        const last_name = this.state.last_name;
        var gender = "";
        const contact_number = this.state.countryPrefix+this.state.contact_number;
        const checkbox = this.refs.terms.checked;
        const birthdate = this.formatDateOnly(this.refs.birthdate.value, '/', '-');
        const recaptcha = this.state.recaptcha;
        const partnerCode = window.location.search.includes("pcode")
          ? window.location.search.split("&")[0].slice(7)
          : null;
        if (this.refs.male.checked) {
            gender = "male";
        }
        else if (this.refs.female.checked) {
            gender = "female";
        }
        else {
            gender = "";
        }

        if (checkbox) {
            this.props.signup(null,email, password, password_confirmation, first_name, middle_name, last_name, gender, contact_number, birthdate, recaptcha, partnerCode);
            this.setState({submitted: true, recaptcha: ""});
        }
        this.refs.terms.checked = false;
        this.recaptchaInstance.reset();
    },


    handleChange(e) {
        const target = e.target;
        const name = target.name;
        const value = target.value;
        
        this.setState({
            [name]:value
        });
      },

    handleEnable(){
        if(this.state.first_name && this.state.last_name && this.state.email && this.state.password && 
            this.state.password_confirmation && this.state.contact_number && this.state.contact_number && 
            this.state.recaptcha && this.refs.terms.checked){
           return false;
        }
        return true;
    },

    verifyCallback(response) {
        this.setState({recaptcha: response,});
    },

    callback() {
    },

    formatDateOnly(arr, separator, format) {
        if (arr) {
            if (separator === "/") {
                arr = arr.split(separator);
                arr.unshift(arr[arr.length - 1]);
                arr.pop();
                return arr.join(format);
            } else if (separator === "-") {
                arr = arr.split(separator);
                arr.push(arr[0]);
                arr.shift();
                return arr.join(format);
            }
        }
        return arr;
    },
    handleShowPassword(e) {
      const name = e.target.name;
      if (this.refs['show_'+name].checked) {
        this.refs[name].type = 'text';
      } else {
        this.refs[name].type = 'password';
      }
    },

    injectMediaDonutScript() {
        const axel = Math.random() + "";
        const a = axel * 10000000000000;
        document.write(`<iframe title=${uuid()} src=https://9848754.fls.doubleclick.net/activityi;src=9848754;type=signu0;cat=signu0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=${a}? width="1" height="1" frameBorder="0" style="display:none"></iframe>`);
      },

    queryParam(key) {
        // eslint-disable-next-line no-useless-escape
        key = key.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + key + "=([^&#]*)").exec(window.location.search);
        return null === regex ? "" : decodeURIComponent(regex[1].replace(/\+/g, " "))
    },

    handleWidget(e) {
      e.preventDefault();
      window.FreshWidget.show();
    },
    render() {
        let captchaSize = 'default';

        if (window.innerWidth < 350) {
            captchaSize = 'compact';
        }

        return (
            <div>
                {/* 
                Start of Floodlight Tag: Please do not remove
                Activity name of this tag: Signup page
                URL of the webpage where the tag is expected to be placed: https://www.shippingcart.com/signup
                This tag must be placed between the <body> and </body> tags, as close as possible to the opening tag.
                Creation Date: 02/04/2020
                */}
                <noscript>
                <iframe title={uuid()} src="https://9848754.fls.doubleclick.net/activityi;src=9848754;type=signu0;cat=signu0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1?" width="1" height="1" frameBorder="0" style={{display: 'none'}}></iframe>
                </noscript>
                <MobileHeaderSidenav isAuthenticated={false} isSideNavOpen={false}/>
                <div id="shippingcart_app" className="header-minimal">
                    <header className="site-header header-minimal">
                        <div className="container">
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <Link to='/'>
                            <img alt="icon" src={logo} style={{ height:35, width:210, margin: 25 }} />
                          </Link>
                        </div>

                            <nav className="top-nav">
                                <ul></ul>
                            </nav>
                        </div>
                    </header>
                    <div className="body-wrapper signinpage">
                        <section className="container register" data-do="register-page">
                            <div className="register-wrapper">
                                <div className="register-header">
                                    <div className="back-link">
                                        <Link to="/home"> &#60; Back to home</Link>
                                    </div>
                                    <div className="register-header-text">
                                        <h1>Sign up with ShippingCart</h1>
                                        <p className="register-text">
                                            Start shopping from {warehouseAND} online shops and ship to your doorstep.
                                        </p>
                                    </div>
                                </div>
                                <div className="register-form clearfix">
                                    {this.props.login.errorFB && this.props.login.errorFB.response.data.errors.detail.includes("inactive") ? 
                                      <div className="sc-alert sc-alert-danger">
                                        <span>This account has been archived. To activate it, <a onClick={this.handleWidget}>contact</a> ShippingCart Customer Care.</span>
                                      </div> 
                                    : null }

                                    {this.props.login.errorFB && !this.props.login.errorFB.response.data.errors.detail.includes("inactive") ?
                                      <div className="sc-alert sc-alert-danger">
                                        <span>{this.props.login.errorFB.response.data.errors.detail}</span>
                                      </div>
                                      : null}
                                    <div className="left">
                                        <form id="register-form-form" method="POST" onSubmit={this.handleSubmit}>
                                            <div className="disnone">
                                              <div ref="notify_error" className="sc-alert sc-alert-danger">
                                                {this.props.error && this.props.error.response && this.props.error.response.data.errors.detail === 'Partners Code is invalid' ? (<div> <i className="sc"/> {this.props.error.response.data.errors.detail} </div>) :
                                                  <div><i className="sc"></i>Fill in all the required fields to sign up.</div>
                                                  }
                                              </div>
                                            </div>
                                            <br/><br/>
                                            <div className="form-input group">
                                                <div className="input-wrapper group-input">
                                                    <div className="control">
                                                        <label>First Name </label>&nbsp;
                                                        <label ref="errors_first_name" className="disnone"></label>
                                                        <input autoFocus type="text" ref="first_name" maxLength="20"
                                                               className="register-input form-control letter-only "
                                                               name="first_name" defaultValue=""
                                                               onChange={this.handleChange}/>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input">
                                                    <div className="control">
                                                        <label>Last Name</label>&nbsp;
                                                        <label ref="errors_last_name" className="disnone"></label>
                                                        <input type="text" ref="last_name" maxLength="20"
                                                               className="register-input form-control letter-only "
                                                               name="last_name" defaultValue=""
                                                               onChange={this.handleChange}/>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input">
                                                    <div className="control">
                                                        <label>Email Address </label>&nbsp;
                                                        <label ref="errors_email" className="disnone"></label>
                                                        <input type="email" ref="email" maxLength="50"
                                                               className="register-input form-control "
                                                               name="email" defaultValue=""
                                                               onChange={this.handleChange}/>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input">
                                                    <div className="control ">
                                                      <label>Password</label>&nbsp;
                                                      <label ref="errors_password" className="disnone"></label>
                                                      <div className="input-group">
                                                        <input type="password"
                                                          ref="password" maxLength="100"
                                                          className="register-input form-control"
                                                          name="password" defaultValue=""
                                                          onChange={this.handleChange}/>
                                                        <div className="input-group-addon">
                                                          <div className="checkbox checkbox_nomargin">
                                                            <input
                                                              id="show_password"
                                                              name="password"
                                                              type="checkbox"
                                                              ref="show_password"
                                                              onClick={(e) => this.handleShowPassword(e)}
                                                            />
                                                            <label htmlFor="show_password">SHOW</label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input">
                                                    <div className="control">
                                                      <label>Re-enter Password</label>&nbsp;
                                                      <label ref="errors_password_confirmation" className="disnone"></label>
                                                      <div className="input-group">
                                                        <input type="password" ref="password_confirmation"
                                                          maxLength="100" className="register-input form-control"
                                                          name="password_confirmation" defaultValue=""
                                                          onChange={this.handleChange}/>
                                                        <div className="input-group-addon">
                                                          <div className="checkbox checkbox_nomargin">
                                                            <input
                                                              id="show_password_confirmation"
                                                              name="password_confirmation"
                                                              type="checkbox"
                                                              ref="show_password_confirmation"
                                                              onClick={(e) => this.handleShowPassword(e)}
                                                              />
                                                            <label htmlFor="show_password_confirmation">SHOW</label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input">
                                                  <div className="control">
                                                    <label>Contact Number</label>&nbsp;
                                                      <label ref="errors_phone_number" className="disnone"></label><br/>
                                                      <div style={{display:'flex'}}>
                                                        <div className="mobile-country">
                                                          <select onChange={this.handleChange} name="countryPrefix">
                                                            {mapPrefixNumber.map(prefix => 
                                                              <option value={prefix.value}>{prefix.label}</option>
                                                            )}
                                                          </select>
                                                        </div>
                                                        <input type="text" ref="phone_number" maxLength="10" style={{margin:'0px 0px 0px 71px'}}
                                                             className="register-input form-control "
                                                             name="contact_number" defaultValue=""
                                                             autoComplete="off"
                                                             onChange={this.handleChange}/>
                                                      </div>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input">
                                                    <div className="control">
                                                        <label>Gender</label>
                                                        <label ref="errors_gender" className="disnone"></label>
                                                        <div className="break">
                                                            <div className="radio">
                                                                <input id="customer-gender-male" type="radio"
                                                                       name="customer_gender" value="male" ref="male"
                                                                       defaultChecked/>

                                                                <label htmlFor="customer-gender-male">Male</label>
                                                            </div>
                                                            <div className="radio">
                                                                <input id="customer-gender-female" type="radio"
                                                                       name="customer_gender" value="female"
                                                                       ref="female"/>
                                                                <label htmlFor="customer-gender-female">Female</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input">
                                                    <div className="control">
                                                        <label>Birthdate <em>(optional)</em></label>
                                                        <label ref="errors_birthdate" className="disnone"></label>
                                                        <div className="input-group calendar" data-do="datetime">
                                                            <span className="view">mm/dd/yyyy</span>
                                                            <input id="datepicker" type="text" name="customer_birthdate"
                                                                   className="form-control" ref="birthdate" readOnly />
                                                            <span className="input-group-addon">
                                                                <i className="fa fa-calendar"></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input captcha">
                                                    <div className="control">
                                                        <label ref="errors_recaptcha" className="disnone"></label>
                                                        <Recaptcha sitekey="6Ld0ERUUAAAAAP_R4QOXrx2K-furHNW55cv26LGF"
                                                          size={captchaSize} render="explicit"
                                                          verifyCallback={this.verifyCallback}
                                                          onloadCallback={this.callback}
                                                          ref={e => this.recaptchaInstance = e}
                                                          onChange={this.handleChange}/>
                                                    </div>
                                                </div>
                                                <div className="input-wrapper group-input">
                                                    <div className="control terms-checkbox">
                                                        <div className="checkbox">
                                                            <input id="terms-accepted" type="checkbox"
                                                                   name="terms" data-do="terms-accept"
                                                                   data-on="change" ref="terms"
                                                                   onChange={this.handleChange}/>
                                                            <label className="terms-accepted" htmlFor="terms-accepted">
                                                                Signing up for ShippingCart account means you accept our
                                                                <Link to="/terms-conditions"> Terms and Conditions</Link> and
                                                                <Link to="/privacy-policy"> Privacy Policy</Link>.
                                                                This also subscribes you to our communication updates to give you access to promos and announcements. You can unsubscribe anytime!
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="submit-group group">
                                                <div className="register-btn">
                                                    <button disabled={this.handleEnable()} type="submit"
                                                            className="btn btn-register align-right btn-orange">
                                                        Sign up
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                        <span className="or">or</span>
                                    </div>
                                    <div className="right">
                                        <div className="fb-register group">
                                        <div id="fb-root"></div>
                                        {/* <div className="sc-warning" style={{ width: '270px', marginBottom: '5px', display: 'inline-flex' }}>
                                          <div style={{ alignSelf: 'center' }}>
                                            <i
                                              className="fa fa-exclamation-circle"
                                              style={{ marginRight: '10px', color: '#feab10' }}
                                            />
                                          </div>
                                          Facebook sign up is temporarily unavailable.
                                        </div> */}
                                            {!window.location.search.includes("pcode") && <a className="btn-facebook clearfix">

                                                <FacebookLogin socialId={fbAppId} language="en_US" 
                                                               fields="email" scope="public_profile,user_friends,email"
                                                               responseHandler={this.responseFacebook} xfbml={false}
                                                               version="v8.0" className="custombtnfacebook"
                                                               buttonText="Sign Up Using Facebook"/>
                                            </a>}
                                            <div className="login-link">
                                                <span>Already registered? <Link to="/signin">Sign in</Link></span>
                                            </div>
                                        </div>
                                        {/* <div className="signup-ad">
                                          <img src="https://cdn.shippingcart.com/assets/xbox-signup-banner-20180814115932.jpg" alt="banner-ad"/>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            <div className="bottom-shadow-wrapper">
                                <div className="shadow"></div>
                            </div>
                        </section>
                    </div>

                    <Footer currentPath={this.props.location.pathname} currentYear={this.props.login.year}/>
                </div>
            </div>
        )
    },
});

export default SignUp;


/** WEBPACK FOOTER **
 ** ./src/components/SignUp.js
 **/